module.exports = __webpack_public_path__ + "img/bkg-rhino-girl.7f81c202.png";